
import { defineComponent, onMounted, ref, watch } from 'vue';

export default defineComponent({
  name: 'FieldErrors',

  props: {
    errors: {
      type: Object,
      required: false,
      default() {
        return {};
      },
    },

    field: {
      type: String,
      required: true,
      default: '',
    },

    silent: {
      type: Boolean,
      required: false,
      default: false,
    },
  },

  setup(props: {errors: any; field: string; silent: boolean}) {
    const fieldErrors: any = ref(null);

    const getFieldFromObject = () => {
      const fieldNames = props.field.split('.');
      // Handle both Ref objects (with .value) and plain objects
      let result = props.errors;
      if (result && typeof result === 'object' && 'value' in result) {
        result = result.value;
      }
      if (!result || typeof result !== 'object') {
        return null;
      }

      for (let i = 0; i < fieldNames.length; i++) {
        const fn = fieldNames[i];
        if (Object.prototype.hasOwnProperty.call(result, fn)) {
          result = result[fn];
        } else {
          return null;
        }
      }

      return result;
    };

    onMounted(() => {
      fieldErrors.value = getFieldFromObject();
    });

    watch(() => props.errors, () => {
      fieldErrors.value = getFieldFromObject();
    }, { deep: true });

    return {
      fieldErrors,
    };
  },
});
